export default "__VITE_ASSET__86ff1156__"